<!-- 加入我们 -->
<template>
  <div class="box">
    <el-drawer :visible.sync="drawer" custom-class="ri_drawer" size="50%" :with-header="false">
      <p @click="goRecharge()">Recharge</p>
      <p @click="openquery()">Facebook Inquire</p>
      <p @click="gopage('becomeagency')">Agency</p>
      <p @click="gopage('aboutus')">About Us</p>
      <p></p>
    </el-drawer>
    <div v-if="isdown" class="tablogo">
      <h1 class="logo"></h1>
      <i @click="drawer = true" class="el-icon-s-unfold right_icon"></i>

    </div>
    <div class="topbox">
      <div class="logobtns">
        <h1 class="logo"></h1>
        <!-- <button class="regbtn"  @click="goRecharge()">Recharge</button>  -->
        <!-- <el-button  @click="openquery()"  type="primary" icon="el-icon-search" circle></el-button> -->
        <i @click="drawer = true" class="el-icon-s-unfold right_icon"></i>
      </div>
      <img class="imgs img1" src="../../assets/images/liveimg/pic1@2x2.png" alt="">
      <div class="socials">
        <h4 class="title1"></h4>
        <a href="https://apps.apple.com/id/app/id1517789247"><button class="appstore"></button></a>
        <!-- <a href="https://play.google.com/store/apps/details?id=com.wheat.mango"><button class="googlelpay"></button></a> -->
        <a href="https://mango-file.oss-ap-southeast-1.aliyuncs.com/mango_of.apk"><button class="download"></button></a>
      </div>

      <img class="imgs img2" src="../../assets/images/liveimg/pic2@2x.png" alt="">
      <h4 class="title2"></h4>
      <p class="title2_txt">Dancers, singers & surprises!<br> Watch and participate in broadcasting lives.</p>
      <img class="imgs img3" src="../../assets/images/liveimg/pic3@2x.png" alt="">
      <h4 class="title3"></h4>
      <p class="title3_txt">Lovely, romantic, funny gifts</p>
    </div>
    <div class="footer">
      <p>Follow Us On</p>
      <div class="icons">
        <a class="icon1" href=" https://www.facebook.com/Mango-live-Indonesia-110210587385704/"></a>
        <a class="icon2" href="https://www.instagram.com/mangolive.tv/"></a>
        <a class="icon3" href=" https://twitter.com/MangoLive6"></a>
      </div>
      <p @click="gopage('agreement')" class="txtline">Agreement</p>
      <p @click="gopage('privacy')" class="txtline">Privacy</p>
      <p @click="gopage('aboutus')" class="txtline">About Us</p>
      <p @click="gopage('community')" class="txtline">Community Rules</p>
      <p @click="gopage('becomeagency')" class="txtline">Become Agency</p>
      <p @click="gopage('broadcasters')" class="txtline">Host Violation Regulation</p>
      <p  class="txtline"><a href="./review.html">Layanan Pengaduan Konsumen</a></p>
      <p class="Copyright">Copyright 2019-{{year}} APPXYZ MOBILE COMPANY LIMITED. All Rights Reserved.</p>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      isIOS: false,
      drawer: false,
      istab: false,
      i: 0,
      isdown: false,
      queryinput: "",
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  created() {
    this.isIOS = this.isIos();
    //   alert(this.isIOS)
    this.queryinput = this.$route.query.code;
    console.log(this.queryinput);
    if (this.queryinput) {
      this.openquery();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    // 监听（绑定）滚轮 滚动事件
  },
  methods: {
    download() {
      window.location.href = "";
    },
    openquery() {
      var _this = this;
      _this
        .$prompt(
          "Enter Your Facebook UserID",
          "Facebook Authorization Information Inquire",
          {
            confirmButtonText: "Check",
            showCancelButton: false,
            inputValue: _this.queryinput,
            customClass: "h5BOXclass",
          }
        )
        .then(({ value }) => {
          console.log(value);
          if (value == null || !value) {
            _this.$message({
              customClass: "h5msg",
              type: "error",
              message: "Enter Your Facebook UserID",
            });
            return;
          }
          _this.$http
            .get(_this.$api.trackDeletion, {
              params: { confirmationCode: value },
            })
            .then(function (response) {
              console.log(response);
              var tape = "warning";
              var txt = "Unauthorized";
              if (response.data.msg == "AUTHORIZED") {
                tape = "success";
                txt = "Authorized";
              } else if (response.data.msg == "UNAUTHORIZED") {
                tape = "warning";
                txt = "Unauthorized";
              } else if (response.data.msg == "UNBUNDLING") {
                tape = "error";
                txt = "Deleted";
              } else {
                tape = "error";
                txt = response.data.msg;
              }
              // success  Authorized / warning Unauthorized / error Deleted
              _this
                .$confirm(txt, "", {
                  confirmButtonText: "ok",
                  showCancelButton: false,
                  customClass: "h5pcokclass",
                  type: tape,
                })
                .then(() => {});
            });
        });
    },
    gopage(page) {
      this.$router.push({ name: page });
    },
    goRecharge() {
      this.$router.push({ path: "/h5recharge" });
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scroll < 0) {
        this.isdown = false;
      } else {
        if (scrollTop > 50) {
          this.isdown = true;
        }
      }
    },

    isIos() {
      var equipmentType = "";
      var agent = navigator.userAgent.toLowerCase();
      var android = agent.indexOf("android");
      var iphone = agent.indexOf("iphone");
      var ipad = agent.indexOf("ipad");
      if (android != -1) {
        equipmentType = false;
      }
      if (iphone != -1 || ipad != -1) {
        equipmentType = true;
      }
      return equipmentType;
    },
  },
};
</script>
<style lang="less" scoped>
.topbox {
  width: 100%;
  height: 52.27rem;
  background: url("../../assets/images/liveimg/ML_bg.png");
  background-size: 100% 100%;
}
.tablogo {
  width: 100%;
  height: 1.8rem;
  display: flex;
  top: 0;
  padding: 0 0.6rem;
  box-sizing: border-box;
  position: fixed;
  z-index: 999;
  justify-content: space-between;
  align-items: center;
  background: #ffff;
  animation: txtimg 1s;
  opacity: 1;
  .logo {
    width: 3.46rem;
    height: 0.6rem;
    background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
    background-size: 100% 100%;
  }
  .regbtn {
    width: 2.4rem;
    height: 0.67rem;
    line-height: 0.67rem;
    font-size: 0.38rem;
    background: linear-gradient(
      270deg,
      rgba(92, 46, 232, 1),
      rgba(202, 90, 245, 1)
    );
    border-radius: 1rem;
    color: rgba(255, 255, 255, 1);
  }
}
@keyframes txtimg {
  0%,
  to {
    opacity: 0;
    top: -888px;
  }
  100% {
    opacity: 1;
    top: 0;
  }
}
.logobtns {
  width: 100%;
  height: 1.8rem;
  display: flex;
  padding: 0 0.6rem;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: 3.46rem;
    height: 0.6rem;
    background: url("../../assets/images/liveimg/LOGO_phone@2x.png");
    background-size: 100% 100%;
  }
  .regbtn {
    width: 2.4rem;
    height: 0.67rem;
    line-height: 0.67rem;
    font-size: 0.38rem;
    background: linear-gradient(
      270deg,
      rgba(92, 46, 232, 1),
      rgba(202, 90, 245, 1)
    );
    border-radius: 1rem;
    color: rgba(255, 255, 255, 1);
  }
}
.socials {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title1 {
    width: 6.56rem;
    height: 1.26rem;
    margin: 0.6rem 0 0.88rem 0;
    background: url("../../assets/images/liveimg/Beautyplatform@2x.png");
    background-size: 100% 100%;
  }
  button {
    width: 4.82rem;
    height: 1.22rem;
    margin-bottom: 0.52rem;
  }
  .appstore {
    background: url("../../assets/images/liveimg/AppStore_phone@2x.png");
    background-size: 100% 100%;
  }
  .download {
    background: url("../../assets/images/liveimg/Download_phone@2x.png");
    background-size: 100% 100%;
  }
  .googlelpay {
    background: url("../../assets/images/liveimg/GooglePlay_phone@2x.png");
    background-size: 100% 100%;
  }
}
.imgs {
  display: block;
  margin: 0 auto;
}
.img1 {
  width: 7.5rem;
  // height: 9.95rem;
  margin: 0 0 0 .6rem;
}
.img2 {
  width: 7.78rem;
  height: 9.95rem;
  margin-top: 1.56rem;
}
.img3 {
  width: 100%;
  height: auto;
  margin-top: 1.56rem;
}
.title2 {
  width: 6.2rem;
  height: 0.43rem;
  margin: 1.3rem auto 0.54rem auto;
  background: url("../../assets/images/liveimg/Meettalents.@2x.png");
  background-size: 100% 100%;
}
.title3_txt,
.title2_txt {
  width: 100%;
  text-align: center;
  font-size: 0.32rem;
  color: rgba(48, 48, 48, 1);
}
.title3 {
  width: 5.76rem;
  height: 1.26rem;
  margin: 0.9rem auto 0.52rem auto;
  background: url("../../assets/images/liveimg/ImpressGifts@2x.png");
  background-size: 100% 100%;
}
.footer {
  width: 100%;
  height: 9.07rem;
  display: flex;
  flex-direction: column;
  background: rgba(0, 0, 0, 1);
  align-items: center;
  color: #fff;
  justify-content: space-between;
  font-size: 0.32rem;
  padding: 0.8rem 0;
  box-sizing: border-box;
  .icons {
    display: flex;
    width: 4.28rem;
    justify-content: space-between;
    .icon1 {
      width: 1.07rem;
      height: 1.07rem;
      background: url("../../assets/images/liveimg/facebook_phone@2x.png");
      background-size: 100% 100%;
    }
    .icon2 {
      width: 1.07rem;
      height: 1.07rem;
      background: url("../../assets/images/liveimg/instagram_phone@2x.png");
      background-size: 100% 100%;
    }
    .icon3 {
      width: 1.07rem;
      height: 1.07rem;
      background: url("../../assets/images/liveimg/twitter_phone@2x.png");
      background-size: 100% 100%;
    }
  }
  p {
    font-size: 0.32rem;
  }
  .txtline {
    text-decoration: underline;
    a{
      color: #fff;
    }
  }
  .Copyright {
    color: rgba(160, 160, 160, 1);
    margin-top: 1.06rem;
    text-align: center;
    line-height: 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5home.vue